import { GenericTabModel } from "../models/tabs/generic-tab";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: GenericTabModel
})
export class TabsCollection extends Backbone.Collection<GenericTabModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/tabs-collection.ts